if (!customElements.get('modal-content')) {
    customElements.define('modal-content',
class ModalContent extends HTMLElement {
    constructor() {
      super();
      this.modal = this.closest('.modal');
      this.show = this.show.bind(this);
      this.hide = this.hide.bind(this);
      
      this.modal.addEventListener(
        "click", (event) => {
            if (event.target === this.modal) this.hide();
        }
      );

      document.addEventListener("klaviyoChecked", (event) => {
        if(event && event.detail) {
          this.show();
        }
      });

      document.addEventListener("keyup", (event) => {
        if (event.code && event.code.toUpperCase() === "ESCAPE") this.hide();
      });

    }
  
    show() {
      this.openedBy = opener;
      document.body.classList.add("overflow-hidden");
      this.closest('.modal').setAttribute("open", "true");
    }
  
    hide() {
      document.body.classList.remove("overflow-hidden");
      this.closest('.modal').removeAttribute("open");
    }
  }
);
}
